import BaseRequest from './BaseRequest'

export default class HotWalletRequest extends BaseRequest {

  createEOSAddress(params) {
    let url = '/admin/hotwallet/create-eos-receive-address';
    return this.post(url, params);
  }
}
